import styled, { keyframes } from 'styled-components';

import { BREAK_POINTS } from '@origin-digital/style-guide';

import { Heading } from '../common';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const Layout = styled.div`
  animation: 2s ${fadeIn} ease-in-out;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: flex;

    & > * {
      flex: 1;
    }
    & > *:not(:last-child) {
      padding-right: 16px;
    }
    & > *:last-child {
      padding-left: 16px;
    }
  }
`;

export const ReviewContent = styled.div`
  padding: 24px;
  margin: 0 auto;

  [class*='rates-container'] > div:first-child > div[data-id="text"]:first-child {
    display: none;
  }
  [class^='PlanComparisonCard__PlanBox'] {
    max-width: none;
  }
  [class^='AlignElementHeights__AlignmentWrapper'] {
    height: auto !important;
  }

  [class*='PlanComparisonCard__Banner'] {
    display: none;
  }
  
  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    padding: 32px 0;
    width: 540px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 64px 0;
    width: 720px
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    width: 960px;
  }
  @media screen and(min-width: ${BREAK_POINTS.Min.XL}) {
    width: 1140px;
  }
`;

export const IconPoint = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;

  svg {
    @media screen and (max-width: ${BREAK_POINTS.Max.MD}) {
      width: 24px;
      height: 24px;
    }
  }
  & > *:first-child {
    margin-right: 16px;
  }
`;

export const CTAs = styled.div`
  text-align: center;
  a {
    display: inline-block;
  }
  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: left;
    width: 206px;
  }
`;

export const Spaced = styled.div`
  @media screen and (max-width: ${BREAK_POINTS.Max.MD}) {
    margin-bottom: 32px;
  }
  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const ReviewHeading = styled(Heading)`
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: left;
  }
`;
